export class OTPValidationRequest {

    public id : string;
    public password: string;

}